import classNames from 'classnames';
import { forwardRef } from 'react';
import LazyTextField from '../../../../../../../../../../../components/FormInputs/LazyTextField';
import Typography from '../../../../../../../../../../../components/v2/ui/Typography/Typography';
import teceoInputConfig from '../../../../../../../../../../../utils/TeceoInputConfig';
import { QuantityControlInput } from '../../../../../../../../../components/QuantityControlInput';
import { usePackStyles } from '../../../../styles/usePackStyles';

type PacksMenuItemGridMultiplyMobileProps = {
  readMode: boolean;
  showStock: boolean;
  packMultiplier: number | undefined;
  willConsumeStock?: boolean;
  stockAvailableAmount?: number;
  isPackWithUnavailableStock: boolean;
  handleClickGridMultiply: () => void;
  onClickIncrement: () => void;
  onClickDecrement: () => void;
  handleInput: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const PacksMenuItemGridMultiplyMobile = forwardRef<
  HTMLInputElement | undefined,
  PacksMenuItemGridMultiplyMobileProps
>(
  (
    {
      readMode,
      showStock,
      handleInput,
      packMultiplier,
      onClickIncrement,
      onClickDecrement,
      stockAvailableAmount,
      handleClickGridMultiply,
      isPackWithUnavailableStock,
      willConsumeStock = false,
    },
    ref,
  ) => {
    const { classes: packStyles } = usePackStyles();
    return (
      <>
        <QuantityControlInput
          disabled={readMode}
          onDecrement={onClickDecrement}
          onIncrement={onClickIncrement}
          className={classNames({
            [packStyles.mobileMultiplierErrorBorder]: isPackWithUnavailableStock,
            [packStyles.mobileMultiplierDefaultBorder]: !isPackWithUnavailableStock,
          })}
          Input={
            <LazyTextField
              {...teceoInputConfig}
              type="number"
              className={packStyles.mobileMultiplierTextField}
              InputProps={{
                inputProps: {
                  min: 0,
                  max: stockAvailableAmount ?? 999,
                },
                type: 'number',
              }}
              defaultValue={packMultiplier ?? ''}
              onFocus={(event: React.FocusEvent<HTMLInputElement>) => event.target.select()}
              inputRef={ref}
              onChangeWithDebounce={handleClickGridMultiply}
              onInput={handleInput}
            />
          }
        />

        {stockAvailableAmount !== undefined && showStock && willConsumeStock && (
          <Typography variant="body2" color="textSecondary" className={packStyles.stockQuantity}>
            {stockAvailableAmount}
          </Typography>
        )}
      </>
    );
  },
);

export default PacksMenuItemGridMultiplyMobile;
